import React, { FunctionComponent } from 'react';

import { IReplayConfig } from 'interfaces';
import { Button, ButtonGroup, Tooltip } from 'cfa-react-components';
import { ReplayConfigService } from 'services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

interface IReplayConfigItemProps {
    config: IReplayConfig,
    onEditReplayConfig: (r: IReplayConfig) => void,
    openDeleteModal: (target: any, deleteFunc: (any) => Promise<any>, deleteVerb: string, deleteNoun: string) => void,
    refresh: () => void,
}

export const ReplayConfigItem: FunctionComponent<IReplayConfigItemProps> = ({ config, onEditReplayConfig, openDeleteModal, refresh }) => {
    
    return (
        <tr key={config.replayConfigUUID}>
            <td className='configTable_item'>
                {config.name}<br/>
                <p style={{fontSize: '12px', margin: '6px 6px 0px'}}>{config.replayConfigUUID}</p>
            </td>
            <td className='configTable_item'>{config.sinkType}</td>
            <td className='configTable_item'>{config.sinkParams.location}</td>
            <td className='configTable_item'>{config.sinkParams.secretPath}</td>
            <td className='configTable_item'>{config.timingOption}</td>
            <td className='configTable_item configTable_itemButton'> 
                <ButtonGroup size='sm'>
                    <Tooltip content="Edit" showOnElementDelay={{showDelay: 1000}}>
                        <Button className="itemTable_iconButton" color='secondary'
                            onClick={() => onEditReplayConfig(config)}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </Tooltip>
                    <Tooltip content="Delete" showOnElementDelay={{showDelay: 1000}}>
                        <Button className="itemTable_iconButton" variant="destructive" 
                            onClick={() => openDeleteModal(config.replayConfigUUID, ReplayConfigService.deleteReplayConfig, "Delete", "Replay Config")} >
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    </Tooltip>
                </ButtonGroup>
            </td>
        </tr>
    );
}